import {
  IFabricationMockup,
  IPavement
} from '../../store/ducks/fabrication-mockups/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

export class FabricationMockupsService extends EGerdauService {
  async createFabricationMockup(
    contractNumber: string,
    mockupName: string,
    hasRoof: boolean,
    hasCovering: boolean,
    typicalFloorPlan: string,
    otherTypicalFloorPlan: string,
    pavements: IPavement[]
  ): Promise<IFabricationMockup> {
    const headers = this.getHeaders();

    const bodyRequest = {
      contractNumber,
      mockupName,
      typicalFloorPlan,
      hasRoof,
      hasCovering,
      otherTypicalFloorPlan,
      pavements
    };

    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.MOCKUPS}`,
      bodyRequest,
      { headers }
    );

    return response.data as IFabricationMockup;
  }

  async editFabricationMockup(
    mockupId: number,
    mockupName: string,
    hasRoof: boolean,
    hasCovering: boolean,
    typicalFloorPlan: string,
    otherTypicalFloorPlan: string,
    pavements: IPavement[]
  ): Promise<void> {
    const headers = this.getHeaders();

    const bodyRequest = {
      mockupId,
      mockupName,
      typicalFloorPlan,
      hasRoof,
      hasCovering,
      otherTypicalFloorPlan,
      pavements: pavements.map((p) => {
        return {
          id: p.isNewPavement ? undefined : p.id,
          name: p.name,
          position: p.position
        };
      })
    };

    await customersAuthorizationApi.put(
      `${ECustomerAuthorizationEndpoints.MOCKUPS}/${mockupId}`,
      bodyRequest,
      { headers }
    );
  }

  async loadFabricationMockups(
    contractNumber: string
  ): Promise<IFabricationMockup[]> {
    const headers = this.getHeaders();

    const mockupsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.MOCKUPS}?contractNumber=${contractNumber}`,
      { headers }
    );
    const mockups = mockupsResponse.data as IFabricationMockup[];
    this.sortMockupsByUpdateDate(mockups);

    return mockups;
  }

  private sortMockupsByUpdateDate(mockups: IFabricationMockup[]) {
    mockups.sort(
      (a, b) =>
        new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    );
  }

  async removeFabricationMockup(mockupId: number): Promise<void> {
    const headers = this.getHeaders();
    await customersAuthorizationApi.delete(
      `${ECustomerAuthorizationEndpoints.MOCKUPS}/${mockupId}`,
      { headers }
    );
  }

  async editPavements(
    id: number,
    slabDate?: string,
    beamDate?: string,
    pillarDate?: string,
    slabStatus?: string,
    beamStatus?: string,
    pillarStatus?: string
  ): Promise<void> {
    const headers = this.getHeaders();

    const bodyRequest = {
      id,
      pillarDate,
      beamDate,
      slabDate,
      pillarStatus,
      beamStatus,
      slabStatus
    };
    await customersAuthorizationApi.put(
      `${ECustomerAuthorizationEndpoints.PAVEMENTS}`,
      bodyRequest,
      { headers }
    );
  }
}
